import ConnectedMobileRegistrationSummary from "./RegistrationSummary/ConnectedMobileRegistrationSummary";
import ConnectedRegistrationFooter from "./RegistrationFooter/ConnectedRegistrationFooter";
import ConnectedRegistrationHeader from "./RegistrationHeader/ConnectedRegistrationHeader";
import ConnectedRegistrationNav from "./RegistrationNav/ConnectedRegistrationNav";
import ConnectedRegistrationSummary from "./RegistrationSummary/ConnectedRegistrationSummary";
import ConnectedReturningRegistrationBanner from "./ReturningRegistrationBanner/ConnectedReturningRegistrationBanner";
import ConnectedFCRegistrationBanner from "./FCRegistrationBanner/ConnectedFCRegistrationBanner";
import RegistrationBase from "./RegistrationBase";
import RegistrationContent from "./RegistrationContent/RegistrationContent";
import RegistrationHeader from "./RegistrationHeader/RegistrationHeader";

export default RegistrationBase;

export {
    ConnectedMobileRegistrationSummary,
    ConnectedRegistrationFooter,
    ConnectedRegistrationHeader,
    ConnectedRegistrationNav,
    ConnectedRegistrationSummary,
    ConnectedReturningRegistrationBanner,
    ConnectedFCRegistrationBanner,
    RegistrationContent,
    RegistrationHeader,
};
